var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIosinline = function SvgIosinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ios_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C5D6A",
    d: "M12.476 8.453c0-1.307.587-2.293 1.787-3.04-.667-.96-1.68-1.493-3.013-1.6-1.28-.106-2.667.747-3.174.747-.533 0-1.76-.693-2.72-.693-2 .026-4.106 1.573-4.106 4.746 0 .933.16 1.893.507 2.907.453 1.306 2.106 4.533 3.84 4.48.906-.027 1.546-.64 2.72-.64 1.146 0 1.733.64 2.72.64 1.733-.027 3.226-2.96 3.653-4.267-2.32-1.093-2.214-3.227-2.214-3.28m-2-5.866c.987-1.147.88-2.214.854-2.587-.854.053-1.867.587-2.427 1.253-.613.72-.987 1.574-.907 2.56.907.053 1.76-.426 2.48-1.226"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ios_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIosinline;